import React from "react";
import { RetailerDropShippingInfoPackageDTO } from "@/dto/order/RetailerDropShippingInfoDTO";
import LogisticsCompanyNameMap from "@/map/LogisticsCompanyNameMap";
import { getFirstValidTrackingUrl } from "@/services/trackingUrl";
import { Tag, Tooltip } from "antd";
import LastLogisticsActivity from "./LastLogisticsActivity";
import { observer } from "mobx-react-lite";
import WaybillNoCategory from "@/enum/WaybillNoCategory";

interface RetailerEwaybillProps {
    packageDto: RetailerDropShippingInfoPackageDTO;
}

/**
 * 代理商显示代发电子面单信息
 */
const RetailerEwaybill: React.FC<RetailerEwaybillProps> = function (props) {
    const { packageDto } = props;

    const { waybillNo, logisticsCompany, activity } = packageDto || {};

    if (!(waybillNo && logisticsCompany)) {
        return null;
    }

    const trackingUrl = getFirstValidTrackingUrl(logisticsCompany, waybillNo);

    const content =
        "子母单，是一票多包裹，多个包裹共用一个母运单号，子单号只是用来打印到面单上。仅母单号获取物流信息，订单发货可能只用母单号发货";

    return (
        <div className="waybill-no waybill-no-separator" key={logisticsCompany + waybillNo}>
            <p className="logistics-company-name">{LogisticsCompanyNameMap[logisticsCompany]}</p>

            <p>
                {packageDto?.waybillNoCategory === WaybillNoCategory.CHILD ? (
                    <Tooltip title={content}>
                        <Tag variant="outlined" color="blue" style={{ marginRight: "2px", padding: "0 2px" }}>
                            子
                        </Tag>
                    </Tooltip>
                ) : null}

                {packageDto?.waybillNoCategory === WaybillNoCategory.PARENT ? (
                    <Tooltip title={content}>
                        <Tag variant="outlined" color="blue" style={{ marginRight: "2px", padding: "0 2px" }}>
                            母
                        </Tag>
                    </Tooltip>
                ) : null}

                <Tag
                    variant="outlined"
                    color="#d61d1d"
                    style={{ margin: 0, lineHeight: 1.3, fontSize: 12, padding: "0 2px", marginRight: "1px" }}
                >
                    代
                </Tag>

                <span className="mr5">
                    {trackingUrl ? (
                        <a href={trackingUrl.url} target="_blank">
                            {waybillNo}
                        </a>
                    ) : (
                        waybillNo
                    )}
                </span>
            </p>

            <LastLogisticsActivity
                logisticsCompany={logisticsCompany}
                waybillNo={waybillNo}
                lastLogisticsActivity={activity}
            />
        </div>
    );
};

export default observer(RetailerEwaybill);
